import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ThemeService {
    private initialized = false;

    init(): void {
        if (this.initialized || typeof window === 'undefined') {
            return;
        }
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const applyTheme = (eventOrMatches: MediaQueryList | MediaQueryListEvent) => {
            const matches = eventOrMatches.matches;
            document.documentElement.dataset['theme'] = matches ? 'dark' : 'light';
            document.body.dataset['theme'] = matches ? 'dark' : 'light';
        };
        applyTheme(mediaQuery);
        const listener = (event: MediaQueryListEvent) => applyTheme(event);
        if (typeof mediaQuery.addEventListener === 'function') {
            mediaQuery.addEventListener('change', listener);
        } else {
            // Safari fallback
            mediaQuery.addListener(listener);
        }
        this.initialized = true;
    }
}
